import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBoy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.505 7.125H4.5c.646.006 1.166.23 1.56.595.383.356.62.822.765 1.284.285.912.248 1.94.11 2.5l-.969-.24c.014.3.019.585.011.875-.02.798-.135 1.617-.398 2.843l-.084.396h-2.99l-.084-.396c-.263-1.227-.375-2.046-.393-2.844-.017-.72.043-1.413.125-2.347l.024-.276.996.087-.022.262c-.083.952-.139 1.589-.124 2.25.015.63.094 1.291.29 2.264H3.5V11.74h1v2.637h.184c.196-.974.277-1.635.294-2.265.017-.68-.04-1.333-.126-2.328l-.016-.183.997-.087.018.208c.05.585.093 1.076.115 1.535.096-.398.13-1.235-.095-1.955-.112-.356-.275-.65-.492-.85-.206-.192-.484-.324-.886-.328h-.986c-.402.004-.68.136-.886.327-.216.202-.38.495-.491.85-.227.725-.192 1.567-.094 1.962l-.97.24c-.14-.56-.176-1.588.11-2.5.144-.462.381-.928.765-1.284.393-.366.913-.59 1.56-.595h.004z"
      fill="#4D4D4D"
    />
    <circle cx={4} cy={5.389} stroke="#4D4D4D" r={1.26} />
  </svg>
);
const Memo = memo(SvgBoy);
export default Memo;
